var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchPhoneNumerPopPupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 143.934,
    viewBox: "0 0 150 143.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4550",
    "data-name": "Group 4550",
    transform: "translate(-549 -344.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4549",
    "data-name": "Group 4549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_transfer_money_re_6o1h",
    transform: "translate(549 344.066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M490.17,446.681a.624.624,0,0,0,.452-1.081l-.043-.17.017-.041a1.676,1.676,0,0,1,3.091.012A14.881,14.881,0,0,1,495,449.125a4.958,4.958,0,0,1-.087,1.7,19.874,19.874,0,0,0,1.808-8.254,19.176,19.176,0,0,0-.119-2.14q-.1-.874-.273-1.735a20.1,20.1,0,0,0-3.987-8.52,5.35,5.35,0,0,1-2.225-2.309,4.076,4.076,0,0,1-.371-1.115,5.038,5.038,0,0,0,.327-1.737c.151-.229.421-.343.586-.567.82-1.112,1.95-.918,2.539.593,1.26.636,1.272,1.69.5,2.7-.492.645-.559,1.518-.991,2.209.044.057.091.112.135.169a20.226,20.226,0,0,1,2.112,3.346,8.411,8.411,0,0,1,.5-3.907,14.088,14.088,0,0,1,2.175-3.139,1.726,1.726,0,0,1,3.075.848l0,.044q-.177.1-.346.212a.846.846,0,0,0,.341,1.54l.017,0a8.438,8.438,0,0,1-.222,1.259c1.018,3.936-1.18,5.37-4.317,5.434-.069.035-.137.071-.206.1a20.656,20.656,0,0,1,1.112,5.232,19.585,19.585,0,0,1-.014,3.163l.005-.037a5.177,5.177,0,0,1,1.767-2.989c1.36-1.117,3.281-1.528,4.748-2.426a.971.971,0,0,1,1.488.945l-.006.039a5.673,5.673,0,0,0-.638.307q-.177.1-.346.212a.846.846,0,0,0,.341,1.54l.017,0,.035.005a8.426,8.426,0,0,1-1.55,2.428c-.636,3.436-3.37,3.762-6.294,2.761h0a20.652,20.652,0,0,1-1.387,4.049h-4.955c-.018-.055-.034-.112-.05-.167a5.63,5.63,0,0,0,1.371-.082c-.368-.451-.735-.906-1.1-1.357a.3.3,0,0,1-.023-.027c-.186-.231-.375-.46-.561-.691h0a8.248,8.248,0,0,1,.242-2.1h0Z",
    transform: "translate(-355.089 -307.238)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M159.753,521.448a.326.326,0,0,0,.327.327H265.464a.327.327,0,1,0,0-.654H160.08a.326.326,0,0,0-.327.327Z",
    transform: "translate(-115.83 -377.841)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4541",
    "data-name": "Group 4541",
    transform: "translate(0 18.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M61.709,191.516H13.2A10.739,10.739,0,0,1,2.476,180.79V76.544A10.739,10.739,0,0,1,13.2,65.818H61.709A10.739,10.739,0,0,1,72.436,76.544V180.789a10.739,10.739,0,0,1-10.726,10.727Z",
    transform: "translate(-1.795 -65.818)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M255.73,205.281a.454.454,0,0,0-.454.454v14.521a.454.454,0,1,0,.908,0V205.735A.454.454,0,0,0,255.73,205.281Z",
    transform: "translate(-185.089 -166.936)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M74.107,79.234V183.478a9.707,9.707,0,0,1-9.073,9.686h0c-.075,0-.15.009-.227.011-.134.007-.268.009-.4.009l-1.411-.1c-.921-.068-2.262-.17-3.934-.3q-.752-.058-1.588-.127c-1.112-.091-2.332-.191-3.642-.3-.522-.043-1.062-.091-1.613-.138-2.818-.243-5.974-.526-9.3-.849q-.844-.078-1.7-.163l-.454-.045c-2.373-.234-34.565-6.455-34.565-7.671V79.234A9.706,9.706,0,0,1,15.9,69.528H21.69a1.769,1.769,0,0,1,1.749,1.645c.007.061.014.123.025.184a1.972,1.972,0,0,0,1.963,1.575H54.868a1.972,1.972,0,0,0,1.963-1.575c.011-.061.018-.123.025-.184a1.769,1.769,0,0,1,1.749-1.645H64.4a9.706,9.706,0,0,1,9.706,9.706Z",
    transform: "translate(-4.487 -68.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M.454,165.67a.454.454,0,0,0-.454.454v3.63a.454.454,0,1,0,.908,0v-3.63A.454.454,0,0,0,.454,165.67Z",
    transform: "translate(0 -138.216)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M.454,205.281a.454.454,0,0,0-.454.454v7.034a.454.454,0,1,0,.908,0v-7.034A.454.454,0,0,0,.454,205.281Z",
    transform: "translate(0 -166.936)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M.454,241.591a.454.454,0,0,0-.454.454v7.034a.454.454,0,0,0,.908,0v-7.034A.454.454,0,0,0,.454,241.591Z",
    transform: "translate(0 -193.263)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1330",
    "data-name": "Rectangle 1330",
    width: 8.849,
    height: 1.134,
    rx: 0.31,
    transform: "translate(8.282 2.609)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 0.908,
    cy: 0.908,
    r: 0.908,
    transform: "translate(54.645 1.929)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 0.908,
    cy: 0.908,
    r: 0.908,
    transform: "translate(57.141 1.929)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    cx: 0.908,
    cy: 0.908,
    r: 0.908,
    transform: "translate(59.636 1.929)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M94.881,292.716H56.388a1.1,1.1,0,1,1,0-2.2H94.881a1.1,1.1,0,1,1,0,2.2Z",
    transform: "translate(-40.087 -210.64)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_203",
    "data-name": "Ellipse 203",
    cx: 12.299,
    cy: 12.299,
    r: 12.299,
    transform: "translate(22.386 91.446)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M215.959,0H137.335a5.235,5.235,0,0,0-5.229,5.229V59.108a5.235,5.235,0,0,0,5.229,5.229h78.623a5.235,5.235,0,0,0,5.229-5.229V5.229A5.235,5.235,0,0,0,215.959,0Z",
    transform: "translate(-95.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 9.407,
    cy: 9.407,
    r: 9.407,
    transform: "translate(71.095 15.831)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M215.959,0H137.335a5.235,5.235,0,0,0-5.229,5.229V59.108a5.235,5.235,0,0,0,5.229,5.229h78.623a5.235,5.235,0,0,0,5.229-5.229V5.229A5.235,5.235,0,0,0,215.959,0Zm4.68,59.108a4.683,4.683,0,0,1-4.68,4.68H137.335a4.683,4.683,0,0,1-4.68-4.68V5.229a4.683,4.683,0,0,1,4.68-4.68h78.623a4.683,4.683,0,0,1,4.68,4.68Z",
    transform: "translate(-95.784)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4542",
    "data-name": "Group 4542",
    transform: "translate(63.379 5.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M238.935,19.35H231.22a.705.705,0,0,0,0,1.41h7.715a.705.705,0,0,0,0-1.41Z",
    transform: "translate(-230.516 -19.35)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M285.935,19.35H278.22a.705.705,0,0,0,0,1.41h7.715a.705.705,0,0,0,0-1.41Z",
    transform: "translate(-264.593 -19.35)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M332.935,19.35H325.22a.705.705,0,0,0,0,1.41h7.715a.705.705,0,0,0,0-1.41Z",
    transform: "translate(-298.671 -19.35)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M222.766,134.516h-48.5c-2.018,0-3.659,1.22-3.659,2.722V139.7c0,1.5,1.641,2.722,3.659,2.722h48.5c2.018,0,3.659-1.22,3.659-2.722v-2.458C226.425,135.736,224.784,134.516,222.766,134.516Z",
    transform: "translate(-111.606 -92.51)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M67.212,177.432l-2.263-1.072a16.618,16.618,0,0,1,2.156,4.928,16.6,16.6,0,0,1,3.05-4.43l-2.391.615c1.474-7.222,7.016-12.407,13.364-12.407v-.55c-6.63,0-12.411,5.4-13.915,12.916Z",
    transform: "translate(-47.092 -119.283)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M70.455,245.716h-14.3a1.1,1.1,0,0,1,0-2.2h14.3a1.1,1.1,0,0,1,0,2.2Z",
    transform: "translate(-39.92 -176.562)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4546",
    "data-name": "Group 4546",
    transform: "translate(77.729 34.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M443.341,235.362,443.2,246.59,440.4,256.6l-2.233-.833.991-9.175-.13-12.416Z",
    transform: "translate(-395.427 -203.812)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 2.649,
    cy: 1.573,
    rx: 2.649,
    ry: 1.573,
    transform: "translate(41.398 56.444) rotate(-79.681)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M441.126,189.861s4.786.066,4.782,2.608c0,1.435-.311,14.468-1.168,22.386-.662,6.106-1.925,7.7-1.925,7.7l-3.024-6.874,1.335-25.819Z",
    transform: "translate(-396.602 -171.681)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M401.577,249.359H385.413c1.355-3.023,2.188-5.9.886-8.192l15.278-.886A17.256,17.256,0,0,0,401.577,249.359Z",
    transform: "translate(-357.175 -208.239)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M400.572,174.688l-6.421-.443-2.657,3.321-1.347.245a4.1,4.1,0,0,0-3.367,4.219l.524,11.909,15.348,1.119,3.677-15.507-4.428-1.763-1.329-3.1Z",
    transform: "translate(-358.164 -160.359)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4543",
    "data-name": "Group 4543",
    transform: "translate(0 17.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M285.959,186.608a3.5,3.5,0,0,1,.953,1.353l4.586,3.63-1.791,2.132-4.46-3.912a3.5,3.5,0,0,1-1.446-.8c-1.041-.936-1.4-2.232-.806-2.894s1.922-.44,2.963.5h0Z",
    transform: "translate(-282.709 -185.73)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M332.906,190.754h0l-17.574,11.866-12.6-8.766,1.891-3.426,9.915,5.762,9.143-7.021c3.256-3.058,7.337-2.465,9.222,1.584Z",
    transform: "translate(-297.229 -186.821)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_206",
    "data-name": "Ellipse 206",
    cx: 4.764,
    cy: 4.764,
    r: 4.764,
    transform: "translate(34.054 3.364)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M413.372,132.442v.924L408,131.853l-4.028.844a4.205,4.205,0,0,0-.531-1.749,2.647,2.647,0,0,1,.011,1.859l-.542.113a1.1,1.1,0,0,0-.481-.575.092.092,0,0,0-.074-.017c-.038.014-.041.063-.041.1.006.2.011.407.019.61l-1.556.324v-.924c-1.493-3.359,2.442-6.266,6.3-6.3a6.289,6.289,0,0,1,6.3,6.3Z",
    transform: "translate(-368.079 -125.484)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M421.715,141.53l-.406-.034c.029-.133.058-.264.084-.4.225-1.113-.27-2.531-.306-3.6-.191,1.13.136,2.521-.2,3.594-.038.119-1.506.889-1.546,1.006-1.625-.594-3.317-2.493-5.233-1.384-1.133.656-2.426.368-3.713.068-.318-.074-.363-1.647-.678-1.709-.564-.111-1.393,1.319-1.925,1.375l2.2-8.523c0-4.637-.43-9.5,5.444-7.862,1.477.412,2.939.736,4.029,1.955a9.274,9.274,0,0,1,2.142,4.87,26.624,26.624,0,0,1,.109,10.64Z",
    transform: "translate(-373.4 -123.74)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4544",
    "data-name": "Group 4544",
    transform: "translate(35.526 91.691)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M433.87,469.038l-2.622.062-1.462-11.78,3.869-.092Z",
    transform: "translate(-424.874 -457.228)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M411.919,488.942h0a.757.757,0,0,0,.7.8h5.2a4.7,4.7,0,0,1,2.6-2.945l.144,2.945h2.685l-.325-4.735s.718-2.533-.773-3.828-.283-1.115-.283-1.115l-.587-2.931-4.057.477-.03,4.6-1.969,4.566-2.888,1.427a.813.813,0,0,0-.423.736Z",
    transform: "translate(-411.919 -471.662)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4545",
    "data-name": "Group 4545",
    transform: "translate(29.201 90.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M397.366,463.218l-2.52.725-4.4-11.023,3.72-1.07Z",
    transform: "translate(-390.023 -451.85)",
    fill: "#ffb7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M388.946,484.362h0a.757.757,0,0,0,.883.6l5.034-1.321a4.7,4.7,0,0,1,1.768-3.508l.887,2.812,2.6-.681-1.516-4.5s.052-2.633-1.719-3.507-.557-1.006-.557-1.006l-1.311-2.686-3.8,1.491,1.139,4.457-.746,4.917-2.431,2.113a.813.813,0,0,0-.223.819Z",
    transform: "translate(-388.916 -465.419)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M382.468,270.767l1.65.55c2.579,4.764,3.673,11.09,3.528,18.718l-2.93,34.261h-4.794l-3.508-38.169-6.186,14.326,4.526,23.842-4.526.461-9.117-24.792,6.349-28.815,15.009-.383Z",
    transform: "translate(-339.554 -230.343)",
    fill: "#2f2e41"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "call_1_",
    "data-name": "call (1)",
    d: "M41.046,43.178a4.7,4.7,0,0,1-2.194-.748,14.265,14.265,0,0,1-3.446-2.577,13.076,13.076,0,0,1-2.588-3.445c-.918-1.67-.762-2.546-.587-2.92a2.331,2.331,0,0,1,.914-.98,4.4,4.4,0,0,1,.714-.379l.069-.03a.667.667,0,0,1,.547-.05,1.6,1.6,0,0,1,.52.4,8.644,8.644,0,0,1,1.3,1.93,1.923,1.923,0,0,1,.255.791,1.249,1.249,0,0,1-.318.743c-.033.045-.065.087-.1.129-.19.249-.231.321-.2.45A4.73,4.73,0,0,0,37.085,38.2a4.534,4.534,0,0,0,1.688,1.124c.134.029.208-.015.465-.211l.114-.087a1.256,1.256,0,0,1,.754-.338h0a1.807,1.807,0,0,1,.794.279,9.524,9.524,0,0,1,1.923,1.291,1.6,1.6,0,0,1,.4.519.673.673,0,0,1-.05.548l-.03.069a4.4,4.4,0,0,1-.381.713,2.331,2.331,0,0,1-.982.912A1.681,1.681,0,0,1,41.046,43.178Z",
    transform: "translate(546.364 410.457)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "call_1_2",
    "data-name": "call (1)",
    d: "M39.439,41.173a3.854,3.854,0,0,1-1.8-.614,11.7,11.7,0,0,1-2.827-2.115,10.728,10.728,0,0,1-2.123-2.826c-.754-1.37-.625-2.089-.481-2.4a1.913,1.913,0,0,1,.75-.8,3.607,3.607,0,0,1,.586-.311l.056-.025a.547.547,0,0,1,.449-.041,1.315,1.315,0,0,1,.427.327,7.091,7.091,0,0,1,1.067,1.584,1.578,1.578,0,0,1,.209.649,1.025,1.025,0,0,1-.261.61l-.079.106c-.156.2-.19.264-.167.369a3.88,3.88,0,0,0,.945,1.4,3.719,3.719,0,0,0,1.385.922c.11.024.17-.012.381-.173l.094-.071a1.03,1.03,0,0,1,.619-.277h0a1.482,1.482,0,0,1,.652.229A7.814,7.814,0,0,1,40.9,38.776a1.315,1.315,0,0,1,.328.426.552.552,0,0,1-.041.45l-.025.056a3.61,3.61,0,0,1-.313.585,1.913,1.913,0,0,1-.806.748A1.379,1.379,0,0,1,39.439,41.173Z",
    transform: "translate(592.905 332.46)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1332",
    "data-name": "Rectangle 1332",
    width: 47,
    height: 7,
    rx: 1,
    transform: "translate(560 464)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1333",
    "data-name": "Rectangle 1333",
    width: 50,
    height: 8,
    rx: 1,
    transform: "translate(600 386)",
    fill: "#dfdfdf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchPhoneNumerPopPupIcon);
export default __webpack_public_path__ + "static/media/switch-phone-numer-pop-pup-icon.e62fe50bfef7664c2f46b750c67c590a.svg";
export { ForwardRef as ReactComponent };